import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';
import FilterIconSvg from '@icons/filter.svg';

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  min-height: 38px;
  gap: 4px;
  font-size: 14px;
  padding: 2px 6px;
  position: relative;
  padding-left: 30px;
  margin-bottom: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: rgba(0,0,0,0.04);
`;

export const FilterIcon = styled(FilterIconSvg)`
  font-size: 26px;
  position: absolute;
  top: 5px;
  left: 5px;
`;

export const TagContainer = styled.div`
  min-height: 32px;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  background-color: rgb(233, 237, 240);
  border-radius: 3px;
  padding: 5px 17px 5px 5px;
  position: relative;
`;

export const DeleteIcon = styled(CloseOutlined)`
  position: absolute;
  top: 10px;
  right: 5px;
  font-size: 12px;
`;

export const TagText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 600px;
  white-space: nowrap;
  margin-right: 5px;
`;

export const TagOperator = styled.div`
  color: #3B3B3B;
  opacity: 0.6;
  font-size: 14px;
  margin-right: 5px;
  line-height: 1;
`;

export const Combinator = styled.span`
  padding: 0 5px;
`;